export const logoVariants = {
  hidden: { opacity: 0, scale: 0.85, rotate: -4, filter: 'blur(4px)' },
  show: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    filter: 'blur(0px)',
    transition: { type: 'spring', stiffness: 280, damping: 24, delay: 0.05 },
  },
};

export const navBarVariants = {
  hidden: { opacity: 0, y: -14 },
  show: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 260, damping: 26 },
  },
};

export const navItemsStagger = {
  show: { transition: { staggerChildren: 0.06, delayChildren: 0.12 } },
};

export const navItemVariants = {
  hidden: { opacity: 0, y: -6 },
  show: { opacity: 1, y: 0, transition: { duration: 0.38, ease: 'easeOut' } },
  exit: {
    opacity: 0,
    y: -4,
    pointerEvents: 'none',
    transitionEnd: { display: 'none' },
    transition: { duration: 0.22, ease: 'easeIn' },
  },
};

// Updated: Removed explicit width animation to avoid forcing 100% which broke navbar layout in inline contexts.
// Uses scaleX + opacity so intrinsic / flex-basis sizing (e.g., .flush styles) remain intact.
export const searchBarVariants = {
  hidden: {
    opacity: 0,
    scaleY: 0.9,
    scaleX: 0.6,
    y: -4,
    originY: 0,
    originX: 0,
  },
  show: {
    opacity: 1,
    scaleY: 1,
    scaleX: 1,
    y: 0,
    transition: {
      opacity: { duration: 0.3, ease: 'easeOut' },
      scaleY: { duration: 0.35, ease: [0.33, 0, 0.2, 1] },
      scaleX: { duration: 0.4, ease: [0.33, 0, 0.2, 1] },
    },
  },
  exit: {
    opacity: 0,
    scaleY: 0.85,
    scaleX: 0.55,
    y: -6,
    transition: { duration: 0.28, ease: 'easeIn' },
  },
};
